import moment from "moment";
import React, { useState } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import "../App.css";
import {
  Card,
  CardText,
  CardTitle,
  List,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [activeListItem, setActiveListItem] = useState(0);
  const navigate = useNavigate();
  const handleListItemClick = (index) => {
    setActiveListItem(index);
  };

  const listItems = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about-us" },
    { name: "Privacy Policy", href: "/privacy-policy" },
    { name: "Terms & Conditions", href: "/terms-condition" },
    { name: "Cancellation & Refund", href: "/cancellation-policy" },
    { name: "Shipping & Cancellation", href: "/shipping-policy" },
    { name: "Contact Us", href: "/contact-us" },
  ];

  const firstColumn = listItems.slice(0, 4); // First 4 items
  const secondColumn = listItems.slice(4); // Remaining items

  return (
    <div style={{ backgroundColor: "#014286" }}>
      <div className="flex w-11/12 mx-auto pt-8 flex-col md:flex-row flex-container">
        <div className="w-full mx-auto flex flex-col lg:flex-row md:gap-3 justify-between items-center">
          <div className="block md:hidden h-full w-full bg-[#014286] flex justify-center items-center p-2">
            <div className="flex items-center space-x-4">
              {/* Logo on the Left */}
              <div className="w-[100%] md:w-[100px]">
                <a href="/">
                  <img
                    src="/assets/srec-header-logo.png"
                    alt="Logo"
                    className="w-full"
                    // onClick={() => navigate("/")}
                  />
                </a>
              </div>

              {/* College Name on the Right */}
              {/* <div className="text-white">
                <div className="relative">
                  <span className="absolute top-[-10px] left-0 text-sm font-bold">
                    SRI
                  </span>
                  <h1 className="text-[35px] mt-3 m-0 font-extrabold uppercase tracking-wide">
                    RAMANUJAR
                  </h1>
                  <h2 className="text-[19px] mt-[-11px] font-bold uppercase tracking-wide">
                    ENGINEERING COLLEGE
                  </h2>
                </div>
              </div> */}
            </div>
          </div>

          <div className="hidden md:block md:w-[70%] w-full">
            <div className="w-full md:py-3 py-2 items-center flex flex-col md:flex-row md:py-5 md:pl-10">
              <a href="/">
                <img
                  className="w-[80%]"
                  src={"/assets/srec-header-logo.png"}
                  alt="logo"
                  // onClick={() => navigate("/")}
                  // style={{cursor:"pointer"}}
                />
              </a>
              {/* <div>
                <h3 className="md:!text-4xl md:w-[100%] leading-8 md:pt-[3%] !text-3xl pt-2 text-center pl-[10px] md:text-left text-[#f70301] font-bold text-light">
                  Sri Ramanujar Engineering College
                </h3>
                <p className="m-0 md:!text-[12px] !text-[45%] !leading-[18px] text-white pt-2 md:pt-0 text-center pb-3 md:w-[500px] mx-auto font-semibold">
                  APPROVED BY AICTE NEW DELHI AND AFFILIATED TO ANNA UNIVERSITY{" "}
                  <br /> ISO 9001:2015 CERTIFIED INSTITUTION & ACCREDITED BY
                  NAAC{" "}
                </p>
              </div> */}
            </div>
          </div>
          <div className="information-div">
            {/* <Card
                            body
                            className="my-2"
                            style={{
                                width: '18rem',
                                background: 'transparent'
                            }}
                        >
                            <CardTitle tag="h5" style={{ color: '#95BBFE', fontWeight: '' }}>
                                Information
                            </CardTitle>
                            <CardText>
                                <ListGroup flush>
                                    {listItems.map((item, index) => (
                                        <ListGroupItem
                                            tag='a'
                                            href={item.href}
                                            className={`custom-list-item text-white bg-transparent mx-2 ${activeListItem === index ? 'active' : 'text-white'}`}
                                            onClick={() => handleListItemClick(index)}
                                            key={index}
                                        >
                                            {item.name}
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </CardText>
                        </Card> */}
            {/* <ListGroup flush>
              {listItems.map((item, index) => (
                <ListGroupItem
                  tag="a"
                  href={item.href}
                  className={`custom-list-item text-white bg-transparent mx-2 ${
                    activeListItem === index ? "active" : "text-white"
                  }`}
                  onClick={() => handleListItemClick(index)}
                  key={index}
                >
                  {item.name}
                </ListGroupItem>
              ))}
            </ListGroup> */}

            <div className="flex text-white">
              {/* First Column */}
              <ListGroup flush>
                {firstColumn.map((item, index) => (
                  <ListGroupItem
                    tag="a"
                    href={item.href}
                    className={`custom-list-item bg-transparent mx-2 border-0 ${
                      activeListItem === index ? "active" : "text-white"
                    }`}
                    onClick={() => handleListItemClick(index)}
                    key={index}
                  >
                    {item.name}
                  </ListGroupItem>
                ))}
              </ListGroup>

              {/* Second Column */}
              <ListGroup flush>
                {secondColumn.map((item, index) => (
                  <ListGroupItem
                    tag="a"
                    href={item.href}
                    className={`custom-list-item bg-transparent mx-2 border-0 ${
                      activeListItem === index + firstColumn.length
                        ? "active"
                        : "text-white"
                    }`}
                    onClick={() =>
                      handleListItemClick(index + firstColumn.length)
                    }
                    key={index + firstColumn.length}
                  >
                    {item.name}
                  </ListGroupItem>
                ))}
              </ListGroup>
            </div>
          </div>
          <div className="lg:w-[30%]">
            <ul className="flex flex-row gap-3 pt-3 pb-4 items-center justify-center text-white mb-0">
              <li className="fs-2 bg-[#2e4388] w-[40px] h-[40px] text-[18px] justify-center flex items-center rounded-md">
                <a
                  href="https://www.instagram.com/sri_ramanujar?igsh=MXBmbDdodHg2OXVlYQ=="
                  target="_blank"
                  style={{ color: "white" }}
                >
                  <FaInstagram />
                </a>
              </li>
              <li className="fs-2 bg-[#2e4388] w-[40px] h-[40px] text-[18px] justify-center flex items-center rounded-md">
                <a
                  href="https://www.facebook.com/share/16KzVkMQbz/"
                  target="_blank"
                  style={{ color: "white" }}
                >
                  <FaFacebookF />
                </a>
              </li>
              {/* <li className="fs-2 bg-[#2e4388] w-[40px] h-[40px] text-[18px] justify-center flex items-center rounded-md">
                <a
                  href="https://twitter.com/srec_edu"
                  style={{ color: "white" }}
                >
                  <FaTwitter />
                </a>
              </li> */}
              <li className="fs-2 bg-[#2e4388] w-[40px] h-[40px] text-[18px] justify-center flex items-center rounded-md">
                <a
                  href="https://www.youtube.com/@sri_ramanujarofficial"
                  target="_blank"
                  style={{ color: "white" }}
                >
                  <FaYoutube />
                </a>
              </li>
              {/* <li className="fs-2 bg-[#2e4388] w-[40px] h-[40px] text-[18px] justify-center flex items-center rounded-md">
                <a
                  href="https://linkedin.com/in/ramanujarcollege"
                  style={{ color: "white" }}
                >
                  <FaLinkedin />
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </div>

      <div className="!flex !mx-auto !h-full !text-center !w-11/12 md:flex-row flex-col !pb-[30px] text-white !justify-center !items-center">
        <div className="w-full !pt-4 md:!pt-8 md:!text-xl text-10px">
          © Copyright {moment().year()} Sri Ramanujar Engineering College. All
          rights reserved
        </div>
      </div>
    </div>
  );
};
export default Footer;
